"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
var _image = _interopRequireDefault(require("@atlaskit/icon/core/image"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const MediaServicesScaleLargeIcon = props => /*#__PURE__*/_react.default.createElement(_base.IconFacade, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 6.007v11.986C5 18.55 5.45 19 6.007 19h11.986C18.55 19 19 18.55 19 17.993V6.007C19 5.45 18.55 5 17.993 5H6.007C5.45 5 5 5.45 5 6.007m-2 0A3.006 3.006 0 0 1 6.007 3h11.986A3.006 3.006 0 0 1 21 6.007v11.986A3.006 3.006 0 0 1 17.993 21H6.007A3.006 3.006 0 0 1 3 17.993z"/><path d="M11.005 17H16.5c.27 0 .5-.228.5-.509v-1.634a.73.73 0 0 0-.167-.44L14.5 11.85a.24.24 0 0 0-.344-.006L11 15l-.821-.821a.25.25 0 0 0-.358 0l-2.465 2.465c-.195.195-.136.356.135.356z"/><circle cx="9" cy="9" r="2"/></g></svg>`
}, props, {
  newIcon: _image.default
}));
MediaServicesScaleLargeIcon.displayName = 'MediaServicesScaleLargeIcon';
var _default = exports.default = MediaServicesScaleLargeIcon;